import React, { useEffect } from "react";
import List from "src/pages/high_risk/list/list";
import Header from "src/pages/high_risk/list/header";

import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import _ from "lodash";

const Index = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();

  // useEffect(() => {
  //   if (user.loggedIn) {
  //     var result = [];
  //     var roles = _.split(user.roles, " ");
  //     _.map(roles, (item) => {
  //       var role = _.split(item, "_");
  //       result.push(_.toInteger(role[1]));
  //     });

  //     dispatch({ type: "STATE", data: { product_ids: result } });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user.loggedIn]);

  // const { state, dispatch } = useProductContext();

  return (
    <div className=" card flex  p-2 border rounded text-xs">
      <Header />
      <List />
    </div>
  );
};

export default React.memo(Index);
